import { Node } from "../../models";
import { distanceType } from "../../models/types";
import { ActiveItemType } from "../../types";
import {
  SET_ACTIVE_GAME_ITEM,
  SET_CURRENT_NODE,
  SET_DIFFICULTIES,
  SET_DISTANCE_GAME_TYPE,
  SET_END_NODE,
  SET_GAME_ANSWERS,
  SET_GAME_GRAPH,
  SET_IS_PLAYING,
  SET_IS_STARTED,
  SET_IS_WON,
  SET_LEVEL_PASSED,
  SET_START_NODE,
} from "../reducers/gameReducer";

export const setDifficulties = (payload: any) => {
  return {
    type: SET_DIFFICULTIES,
    payload,
  };
};

export const setGameGraph = (payload: any) => {
  return {
    type: SET_GAME_GRAPH,
    payload,
  };
};

export const setIsPlaying = (payload: boolean) => {
  return {
    type: SET_IS_PLAYING,
    payload,
  };
};

export const setIsStarted = (payload: boolean) => {
  return {
    type: SET_IS_STARTED,
    payload,
  };
};

export const setIsWon = (payload: boolean) => {
  return {
    type: SET_IS_WON,
    payload,
  };
};

export const setLevelPassed = (payload: number) => {
  return {
    type: SET_LEVEL_PASSED,
    payload,
  };
};

export const setActiveGameItem = (payload: ActiveItemType) => {
  return {
    type: SET_ACTIVE_GAME_ITEM,
    payload,
  };
};

export const setGameDistanceType = (payload: distanceType) => {
  return {
    type: SET_DISTANCE_GAME_TYPE,
    payload,
  };
};

export const setGameAnswers = (payload: any) => {
  return {
    type: SET_GAME_ANSWERS,
    payload,
  };
};

export const setStartNode = (payload: Node | null) => {
  return {
    type: SET_START_NODE,
    payload,
  };
};

export const setEndNode = (payload: Node | null) => {
  return {
    type: SET_END_NODE,
    payload,
  };
};

export const setCurrentNode = (payload: Node | null) => {
  return {
    type: SET_CURRENT_NODE,
    payload,
  };
};
